import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { ISupplierTypeApi } from './base/supplierTypeApi';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { getCultureBrowser } from '../services/utils';

const baseRoute: string = 'SupplierType';

export class SupplierTypeApi extends ISupplierTypeApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }

  getDomainPublic(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    const cultureBrowser = getCultureBrowser();  
    return api.get(`${baseRoute}/domain_public`, {params: { cultureBrowser }});
  }
}
